import { render, staticRenderFns } from "./MailBar.vue?vue&type=template&id=0ff5f2e2&scoped=true"
import script from "./MailBar.vue?vue&type=script&lang=js"
export * from "./MailBar.vue?vue&type=script&lang=js"
import style0 from "./MailBar.vue?vue&type=style&index=0&id=0ff5f2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5f2e2",
  null
  
)

export default component.exports